import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["set"] = "sanctionScreening/set";
    ActionTypes["reset"] = "sanctionScreening/reset";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    set: createAction(ActionTypes.set, (sanctions) => ({
        payload: { sanctions }
    })),
    reset: createAction(ActionTypes.reset, () => ({
        payload: {}
    }))
};
